import React from 'react';

function MoodPicker({ id, label, value, groups, onChange, max = 3, invalid = false }) {
  const selected = Array.isArray(value) ? value : value ? [value] : [];

  const toggle = (item) => {
    if (selected.includes(item)) {
      onChange(selected.filter((mood) => mood !== item));
      return;
    }
    if (selected.length >= max) return;
    onChange([...selected, item]);
  };

  return (
    <div className={`form-group${invalid ? ' field-invalid' : ''}`}>
      <label id={`${id}-label`}>{label}</label>
      <p className="field-note">
        Plutchik’s wheel plus Pain and Social Energy. Choose up to {max}.
      </p>
      <div
        id={id}
        className="mood-wheel"
        role="group"
        aria-labelledby={`${id}-label`}
        tabIndex={-1}
      >
        {groups.map((group) => (
          <div key={group.group} className="mood-group">
            <span className="mood-group-label" style={{ color: group.color }}>
              {group.group}
            </span>
            <div className="mood-chips">
              {group.items.map((item) => {
                const isSelected = selected.includes(item);
                const disabled = !isSelected && selected.length >= max;
                return (
                  <button
                    key={item}
                    type="button"
                    className={isSelected ? 'mood-chip selected' : 'mood-chip'}
                    style={{
                      borderColor: group.color,
                      background: isSelected ? group.color : '#fff',
                      color: isSelected ? '#fff' : '#1f2430',
                      opacity: disabled ? 0.45 : 1,
                    }}
                    onClick={() => toggle(item)}
                    disabled={disabled}
                  >
                    {item}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
      <p className="field-note">
        {selected.length
          ? `Selected (${selected.length}/${max}): ${selected.join(', ')}`
          : `None selected yet (${max} max)`}
      </p>
    </div>
  );
}

export default MoodPicker;
